import React from 'react';

const Commonrightcircle = () => {
    return (
        <div className="u_round-img">
            <img className="u_right-round-top u_absolute" src="/../images/images/right-S-round.png" alt="right-S-round"/>
            <img className="u_right-round-top u_absolute" src="/../images/images/right-B-round.png" alt="right-B-round"/>
            <img className="u_right-round-bottom u_absolute" src="/../images/images/right-B-round.png"
                 alt="right-B-round"/>
            <img className="u_right-round-bottom u_absolute" src="/../images/images/right-S-round.png"
                 alt="right-S-round"/>
            <img className="u_right-dot-top u_absolute" src="/../images/images/right-dot.png" alt="right-dot-top"/>
            <img className="u_right-dot-bottom u_absolute" src="/../images/images/right-dot.png" alt="right-dot-bottom"/>
        </div>
    );
};

export default Commonrightcircle;